var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltipText)?_c('popover',{ref:"popover",attrs:{"content":_vm.tooltipText,"placement":"bottom","popover-class":"keyword-search-popover"}},[_c('keyword-input',_vm._b({on:{"keydown":_vm.onKeydown}},'keyword-input',_vm.$props,false))],1):_c('keyword-input',_vm._b({},'keyword-input',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }